import React from 'react';
import { Container, Row, Col, Nav, Navbar } from 'react-bootstrap';
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

const Layout: React.FC = () => {
  const { logout, currentUser } = useAuth();
  const { t } = useLanguage();

  const handleLogout = () => {
    logout();
  };

  return (
    <Container fluid className="p-0">
      {/* Top Navigation Bar */}
      <Navbar bg="light" expand="lg" className="px-3">
        <Navbar.Brand className="fw-bold">CMS</Navbar.Brand>
        <div className="ms-auto d-flex align-items-center">
          {currentUser && (
            <span className="me-3">
              <strong>{t('welcome')}, {currentUser}</strong>
            </span>
          )}
          <Nav>
            <Nav.Link
              as="button"
              className="text-danger"
              onClick={handleLogout}
            >
              {t('logout')}
            </Nav.Link>
          </Nav>
        </div>
      </Navbar>

      <Row>
        {/* Fixed Navigation Sidebar */}
        <Col xs="1" className="bg-light sidebar p-3 d-flex flex-column">
          <Nav className="flex-column">
            <Nav.Link as={Link} to="/client-list" className="nav-link">
              <div>Client List</div>
              <div>客戶列表</div>
            </Nav.Link>
            <Nav.Link as={Link} to="/engagement" className="nav-link">
              <div>Engagement</div>
              <div>項目</div>
            </Nav.Link>
            <Nav.Link as={Link} to="/invoice" className="nav-link">
              <div>Invoice</div>
              <div>發票</div>
            </Nav.Link>
            <Nav.Link as={Link} to="/kpi" className="nav-link">
              <div>KPI</div>
              <div>關鍵績效指標</div>
            </Nav.Link>
            <Nav.Link as={Link} to="/time-sheet" className="nav-link">
              <div>Time Sheet</div>
              <div>時間表</div>
            </Nav.Link>
            <Nav.Link as={Link} to="/annual-leave" className="nav-link">
              <div>Annual Leave</div>
              <div>年假</div>
            </Nav.Link>
            <Nav.Link as={Link} to="/calendar" className="nav-link">
              <div>Calendar</div>
              <div>日曆</div>
            </Nav.Link>
          </Nav>
          <div className="mt-auto pt-3">
            <Nav className="flex-column">
              <Nav.Link
                as="button"
                className="nav-link text-danger"
                onClick={handleLogout}
              >
                {t('logout')}
              </Nav.Link>
            </Nav>
          </div>
        </Col>

        {/* Main Content Area */}
        <Col xs="11" className="main-content">
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
};

export default Layout;